import React from "react";
import {
  User,
  Package,
  MapPin,
  RotateCcw,
  Wallet,
  Bell,
  FileText,
  Gift,
  LogOut,
  Book,
  Magnet,
} from "lucide-react";

interface ProfileHoverMenuProps {
  onProfile?: () => void;
  onOrders?: () => void;
  onAddresses?: () => void;
  onOrderSubscription?: () => void;
  onWallet?: () => void;
  onRewards?: () => void;
  onNotifications?: () => void;
  onApplications?: () => void;
  onLogout?: () => void;
  onBookings?:()=>void;
  onReferral?:()=>void;
}

interface MenuItemProps {
  icon: React.ReactNode;
  title: string;
  active?: boolean;
  danger?: boolean;
  onClick?: () => void;
}

const MenuItem: React.FC<MenuItemProps> = ({
  icon,
  title,
  active,
  danger,
  onClick,
}) => (
  <button
    onClick={onClick}
    className={`
      w-full
      flex
      items-center
      gap-3
      px-5
      py-3
      rounded-xl
      transition-all
      duration-200
      ${
        active
          ? "bg-[#EAF7D8] text-[#4E7B2F] font-semibold"
          : danger
          ? "text-red-500 hover:bg-red-50"
          : "text-gray-700 hover:bg-gray-100"
      }
    `}
  >
    <div>{icon}</div>

    <span className="text-[15px]">{title}</span>
  </button>
);

const ProfileHoverMenu: React.FC<ProfileHoverMenuProps> = ({
  onProfile,
  onOrders,
  onAddresses,
  onOrderSubscription,
  onWallet,
  onRewards,
  onNotifications,
  onApplications,
  onLogout,
  onBookings,
  onReferral
}) => {
  return (
    <div
      className="
        absolute
        right-0
        top-full
        mt-2
        w-[260px]
        bg-white
        rounded-2xl
        shadow-xl
        border
        border-gray-100
        p-4
        z-50
      "
    >
      <p className="text-xs font-semibold uppercase text-gray-400 mb-3 px-2">
        My Account
      </p>

      <div className="space-y-1">
        <MenuItem
          icon={<User size={18} />}
          title="Profile"
          active
          onClick={onProfile}
        />

        <MenuItem
          icon={<Package size={18} />}
          title="My Orders"
          onClick={onOrders}
        />

        <MenuItem
          icon={<MapPin size={18} />}
          title="Address"
          onClick={onAddresses}
        />

        <MenuItem
          icon={<RotateCcw size={18} />}
          title="Order Subscription"
          onClick={onOrderSubscription}
        />

        <MenuItem
          icon={<Wallet size={18} />}
          title="Wallet"
          onClick={onWallet}
        />

        <MenuItem
          icon={<Gift size={18} />}
          title="Rewards"
          onClick={onRewards}
        />
 <MenuItem
          icon={<Book size={18} />}
          title="My Bookings"
          onClick={onBookings}
        />
         <MenuItem
          icon={<Magnet size={18} />}
          title="My Referral"
          onClick={onReferral}
        />
        <MenuItem
          icon={<Bell size={18} />}
          title="Notifications"
          onClick={onNotifications}
        />


        <MenuItem
          icon={<LogOut size={18} />}
          title="Signout"
          danger
          onClick={onLogout}
        />
      </div>
    </div>
  );
};

export default ProfileHoverMenu;